// extracted by mini-css-extract-plugin
export default {"genericCard":"Ln-z","inline":"Mn-z","mastercard":"Nn-z","discover":"On-z","visa":"Pn-z","amex":"Qn-z","active":"Rn-z"};